import React from 'react';
import InfoContadores from '../../modals-monitoreo/InfoContadores';

const StatBarNew = ({ 
    total, 
    up, 
    unk, 
    down, 
    odd, 
    exc, 
    onStatClick, 
    loading 
}) => {
    const formatValue = (val) => (loading ? '...' : val ?? 0);

    return (
        <div className="stat-bar-new">
            {/* Total Card */}
            <div className="stat-total-card">
                <span className="stat-total-num">{formatValue(total)}</span>
                <span className="stat-total-lbl">Total</span>
            </div>

            {/* Divider */}
            <div className="stat-divider"></div>

            {/* UP Card */}
            <div className="stat-card up">
                <div className="stat-card-info">
                    <span className="stat-card-lbl">UP</span>
                    <span className="stat-card-num">{formatValue(up)}</span>
                    <span className="stat-card-sub">Conectados</span>
                </div>
                <div className="stat-card-dot-wrap">
                    <div className="stat-dot"></div>
                </div>
                <div className="stat-tooltip">
                    <InfoContadores tipo="up" />
                </div>
            </div>

            {/* UNK Card */}
            <div className="stat-card unk">
                <div className="stat-card-info">
                    <span className="stat-card-lbl">UNK</span>
                    <span className="stat-card-num">{formatValue(unk)}</span>
                    <span className="stat-card-sub">Desconocidos</span>
                </div>
                <div className="stat-card-dot-wrap">
                    <div className="stat-dot"></div>
                </div>
                <div className="stat-tooltip">
                    <InfoContadores tipo="unkonwn" />
                </div>
            </div>

            {/* DOWN Card */}
            <div className="stat-card down">
                <div className="stat-card-info">
                    <span className="stat-card-lbl">DOWN</span>
                    <span className="stat-card-num">{formatValue(down)}</span>
                    <span className="stat-card-sub">Desconectados</span>
                </div>
                <div className="stat-card-dot-wrap">
                    <div className="stat-dot"></div>
                </div>
                <div className="stat-tooltip">
                    <InfoContadores tipo="down" />
                </div>
            </div>

            {/* ODD Card */}
            <div className="stat-card odd">
                <div className="stat-card-info">
                    <span className="stat-card-lbl">ODD</span>
                    <span className="stat-card-num">{formatValue(odd)}</span>
                    <span className="stat-card-sub">Inusuales</span>
                </div>
                <div className="stat-card-dot-wrap">
                    <div className="stat-dot"></div>
                </div>
                <div className="stat-tooltip">
                    <InfoContadores tipo="odd" />
                </div>
            </div>

            {/* EXC Card */}
            <div className="stat-card exc">
                <div className="stat-card-info">
                    <span className="stat-card-lbl">EXC</span>
                    <span className="stat-card-num">{formatValue(exc)}</span>
                    <span className="stat-card-sub">Excepciones</span>
                </div>
                <div className="stat-card-dot-wrap">
                    <div className="stat-dot"></div>
                </div>
                <div className="stat-tooltip">
                    <InfoContadores tipo="exception" />
                </div>
            </div>
        </div>
    );
};

export default StatBarNew;
